import { MinusIcon, PlusIcon } from "vega-icons";

import { ThemedIconButton } from "../Buttons/ThemedIconButton";
import { ThemedDropdown } from "../Form/Controls/Dropdown/ThemedDropdown/ThemedDropdown";

type Props = {
  changeZoomLevel: (zoom: "IN" | "OUT") => void;
  isMobile: boolean;
  scale: number;
  setScale: (scale: number) => void;
  documentZoomOptions: { label: string; value: string }[];
};

export const PDFViewerZoomControls = ({
  changeZoomLevel,
  isMobile = true,
  scale,
  setScale,
  documentZoomOptions,
}: Props) => {
  const scalePercent = Math.round(scale * 100);
  const nearestOption =
    documentZoomOptions.length > 0
      ? documentZoomOptions.reduce((prev, curr) =>
          Math.abs(Number(curr.value) - scalePercent) <
          Math.abs(Number(prev.value) - scalePercent)
            ? curr
            : prev,
        ).value
      : String(scalePercent);

  return (
    <>
      {!isMobile && (
        <ThemedIconButton
          ariaLabel="minus"
          dataTestId="pdf-zoom-out"
          icon={<MinusIcon />}
          onClick={() => changeZoomLevel("OUT")}
          size="large"
        />
      )}
      <ThemedDropdown
        isClearable={false}
        name="document-zoom-dropdown"
        onChange={(option) => setScale(Number(option?.value) / 100)}
        options={documentZoomOptions}
        value={nearestOption}
      />
      {!isMobile && (
        <ThemedIconButton
          ariaLabel="plus"
          dataTestId="pdf-zoom-in"
          icon={<PlusIcon />}
          onClick={() => changeZoomLevel("IN")}
          size="large"
        />
      )}
    </>
  );
};
